// ADR-0144 §2 — importador de unidades de postventa (core-api
// /assets/import/*). Dos pasos sobre el mismo archivo: el dry-run no
// escribe; el commit re-valida y aplica todo o nada. Un commit con
// errores responde 422 con el mismo resumen en `details.summary`.

import { unitImportSummarySchema, type UnitImportSummary } from "@bitacorapro/api-types";
import { request, requestBlob } from "../client";
import type { ApiError } from "../error";

function form(file: File): FormData {
  const f = new FormData();
  f.set("file", file);
  return f;
}

export const unitImportApi = {
  dryRun: async (file: File): Promise<UnitImportSummary> => {
    const json = await request<unknown>("POST", "core", "/assets/import/dry-run", {
      body: form(file),
    });
    return unitImportSummarySchema.parse(json);
  },
  commit: async (file: File): Promise<UnitImportSummary> => {
    const json = await request<unknown>("POST", "core", "/assets/import/commit", {
      body: form(file),
    });
    return unitImportSummarySchema.parse(json);
  },
  downloadTemplate: (): Promise<Blob> => requestBlob("GET", "core", "/assets/import/template"),
};

/** El resumen que viaja en un 422 del commit, si viene bien formado. */
export function summaryFromRejection(err: ApiError): UnitImportSummary | null {
  const parsed = unitImportSummarySchema.safeParse(err.details?.["summary"]);
  return parsed.success ? parsed.data : null;
}
